import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  comingSoon: {
    id: 'citcat.coming-soon',
    defaultMessage: '{msaName} (Coming soon)',
  },
  header: {
    id: 'citcat.header',
    defaultMessage: 'Some of our top locations',
  },
});
